import './jquery';
export class StatusBarWidget {
    private element: HTMLElement;
    private notificationIdCounter: number = 0;

    constructor(element: HTMLElement) {
        this.element = element;
    }

    private createNotificationHtml(id: string, text: string, status: string) {
        let iconHtml = '';
        let messageClass = '';

        switch (status) {
            case 'bad':
                iconHtml = '<i class="bi bi-x-lg"></i>';
                messageClass = 'Message--red';
                break;
            case 'ok':
                iconHtml = '<i class="bi bi-check-lg"></i>';
                messageClass = 'Message--green';
                break;
            case 'warn':
                iconHtml = '<i class="bi bi-exclamation-lg"></i>';
                messageClass = 'Message--orange';
                break;
            default:
                iconHtml = '<i class="bi bi-info-lg"></i>';
                messageClass = 'Message--blue';
                break;
        }

        return `
            <div class="Message ${messageClass}" data-id="${id}">
                <div class="Message-icon">${iconHtml}</div>
                <div class="Message-body"><p>${text}</p></div>
                <button class="Message-close js-messageClose" data-id="${id}">
                    <i class="bi bi-x"></i>
                </button>
            </div>
        `;
    }

    setHtml(html: string) {         
        this.element.innerHTML = html;
    }
    
    setStatus(text: string, status: string) {
        const id = `notification-${++this.notificationIdCounter}`;
        const notificationHtml = this.createNotificationHtml(id, text, status);
                                                     
        this.element.insertAdjacentHTML('beforeend', notificationHtml);
                                                 
        this.show(id);
    }

    show(id: string) {
        const notification = this.element.querySelector(`[data-id="${id}"]`);
        if (notification) {                              
            $(notification).find('.js-messageClose').on('click', () => this.hide(id));

            setTimeout(() => {
                this.hide(id);
            }, 9000);

            //notification.hidden = false;
        }
    }

    hide(id: string) {
        const notification = this.element.querySelector(`[data-id="${id}"]`);
        if (notification) {
            $(notification).fadeOut(300, function () {
                notification.remove();
            });
        }
    }
}